<form [formGroup]="formFieldsGroup" (click)="$event.stopPropagation()">
  <eocm-field *ngFor="let field of form.fields"
             [formGroup]="formFieldsGroup"
             [field]="field"
             [isValidationErrorDisplayed]="isValidationErrorsDisplayed"
             (formsShownChange)="formShownChange$.next($event)"
             (submitButtonClicked)="displayFormErrors($event)">
  </eocm-field>
</form>
